// extracted by mini-css-extract-plugin
module.exports = {"Container":"modal-dialog-header_Container___EFma","CloseIcon":"modal-dialog-header_CloseIcon__iMzS3"};